import routerOptions0 from "/var/intelvision/digibms-portal/src/app/router.options.ts";
import routerOptions1 from "/var/intelvision/digibms-portal/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions1,
...routerOptions0,
}